import { FC } from 'react';
import { ImportOutlined } from '@ant-design/icons';
import { ProButton } from '../antd';
import { BaseOperationButtonProps } from './interface';

/** 导入按钮 */
const ImportButton: FC<BaseOperationButtonProps> = props => {
  const { children, text, icon, ...restProps } = props;
  return (
    <ProButton icon={icon} {...restProps}>
      {children || text}
    </ProButton>
  );
};

ImportButton.defaultProps = {
  icon: <ImportOutlined />,
  text: '导入',
};

export default ImportButton;
